'use client';

import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
interface FeedbackProviderProps {
  idx: string;
}

export const FeedbackCounter = ({ idx }: FeedbackProviderProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);

  const queryOptions = isLogin
    ? AuthQueryOptions[
        'post:/wello/v2/auth/point-market/product/{productIdIdx}/feedback'
      ]({
        path: {
          productIdIdx: idx,
        },
      })
    : UnauthQueryOptions[
        'post:/wello/v2/allows/point-market/product/{productIdIdx}/feedback'
      ]({
        path: {
          productIdIdx: idx,
        },
      });

  useQuery({
    ...queryOptions,
    enabled: isLogin !== undefined,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return null;
};
